/** @deprecated */
export const PDF_AUTOSAVE_PROMO = 'pdf-autosave-promo';
/** @deprecated */
export const PDF_WORK_WITH_PAGES_PROMO = 'pdf-work-with-pages-promo';
